import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";

import MainStreamingDashboard from "./pages/main-streaming-dashboard";
import Login from "./pages/login";
import DeviceManagement from "./pages/device-management";

// Devices
import ViewDeviceDetails from "./pages/device-management/components/devices/ViewDeviceDetails";
import AddEditDevice from "./pages/device-management/components/devices/AddEditDevice";
import ViewDeviceGroup from "./pages/device-management/components/device-groups/ViewDeviceGroup";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Home / Streaming */}
          <Route path="/" element={<MainStreamingDashboard />} />
          <Route path="/stream-management" element={<MainStreamingDashboard />} />

          {/* Devices */}
          <Route path="/device-management" element={<DeviceManagement />} />
          <Route path="/device-management/view/:id" element={<ViewDeviceDetails />} />
          <Route path="/device-management/add" element={<AddEditDevice />} />
          <Route path="/device-management/edit/:id" element={<AddEditDevice />} />
          <Route path="/device-management/device-group-details/:id" element={<ViewDeviceGroup />} />

          {/* Auth */}
          <Route path="/login" element={<Login />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
